/**
    How to setup a route can be found here:
    https://github.homeawaycorp.com/traveler/node-traveler-property-ui/wiki/Routing
*/
import RouterActions from '../actions/routerActions';
import ListingActions from '../actions/listingActions';
import CarouselActions from '../actions/carouselActions';
import {getRoutes, availableRoutes} from '../routes';

function matchRoute(pathname, baseUrlPath) {
    const routes = getRoutes(baseUrlPath);
    return routes[pathname] || {id: ''};
}

/* eslint-disable complexity */
function previousMobilePathActions(pathname, baseUrlPath, dispatch) {
    const match = matchRoute(pathname, baseUrlPath);

    switch (match.id) {
        case availableRoutes.AMENITIES:
            dispatch(ListingActions.setAmenityModalOpen(false));
            break;
        case availableRoutes.OWNER_PROFILE:
            dispatch(ListingActions.setOwnerProfileModalOpen(false));
            break;
        case availableRoutes.CAROUSEL:
            dispatch(CarouselActions.setFullScreenState(false));
            break;
        case availableRoutes.VERTICAL_CAROUSEL:
            dispatch(CarouselActions.setVerticalGalleryOpenState({isOpen: false}));
            break;
        case availableRoutes.CIVIL_CODE_DISCLAIMER:
            dispatch(ListingActions.setCivilCodeDisclaimerModalOpen(false));
            break;
        case availableRoutes.DESCRIPTION:
            dispatch(ListingActions.setDescriptionModalOpen(false));
            break;
        case availableRoutes.UNIT_DESCRIPTION:
            dispatch(ListingActions.setUnitDescriptionModalOpen(false));
            break;
        case availableRoutes.INQUIRY:
            dispatch(ListingActions.setInquiryModalOpen(false));
            break;
        case availableRoutes.LOCATION:
            dispatch(ListingActions.setLocationModalOpen(false));
            break;
        case availableRoutes.MAP:
            dispatch(ListingActions.setMapModalOpen(false));
            break;
        case availableRoutes.REVIEWS:
            dispatch(ListingActions.setReviewsModalOpen(false));
            break;
        case availableRoutes.SEARCH:
            dispatch(ListingActions.setSearchModalOpen(false));
            break;
        case availableRoutes.SEARCH_DATE_PICKER:
            dispatch(ListingActions.setSearchDatePickerModalOpen(false));
            break;
        case availableRoutes.SEARCH_GUEST_PICKER:
            dispatch(ListingActions.setSearchGuestPickerModalOpen(false));
            break;
        case availableRoutes.VIRTUAL_TOUR:
            dispatch(ListingActions.setVirtualTourModalOpen(false));
            break;
        case availableRoutes.DATE_PICKER:
            dispatch(ListingActions.closeDatePickerModal());
            break;
        case availableRoutes.GUEST_SELECTOR:
            dispatch(ListingActions.closeGuestSelectorModal());
            break;
        default:
            break;
    }
}
/* eslint-enable complexity */

/* eslint-disable complexity */
function nextMobilePathActions(pathname, baseUrlPath, dispatch) {
    const match = matchRoute(pathname, baseUrlPath);

    switch (match.id) {
        case availableRoutes.AMENITIES:
            dispatch(ListingActions.setAmenityModalOpen(true));
            break;
        case availableRoutes.OWNER_PROFILE:
            dispatch(ListingActions.setOwnerProfileModalOpen(true));
            break;
        case availableRoutes.CAROUSEL:
            dispatch(CarouselActions.setFullScreenState(true));
            break;
        case availableRoutes.VERTICAL_CAROUSEL:
            dispatch(CarouselActions.setVerticalGalleryOpenState({isOpen: true}));
            break;
        case availableRoutes.CIVIL_CODE_DISCLAIMER:
            dispatch(ListingActions.setCivilCodeDisclaimerModalOpen(true));
            break;
        case availableRoutes.DESCRIPTION:
            dispatch(ListingActions.setDescriptionModalOpen(true));
            break;
        case availableRoutes.UNIT_DESCRIPTION:
            dispatch(ListingActions.setUnitDescriptionModalOpen(true));
            break;
        case availableRoutes.INQUIRY:
            dispatch(ListingActions.setInquiryModalOpen(true));
            break;
        case availableRoutes.LOCATION:
            dispatch(ListingActions.setLocationModalOpen(true));
            break;
        case availableRoutes.MAP:
            dispatch(ListingActions.setMapModalOpen(true));
            break;
        case availableRoutes.REVIEWS:
            dispatch(ListingActions.setReviewsModalOpen(true));
            break;
        case availableRoutes.SEARCH:
            dispatch(ListingActions.setSearchModalOpen(true));
            break;
        case availableRoutes.SEARCH_DATE_PICKER:
            dispatch(ListingActions.setSearchDatePickerModalOpen(true));
            break;
        case availableRoutes.SEARCH_GUEST_PICKER:
            dispatch(ListingActions.setSearchGuestPickerModalOpen(true));
            break;
        case availableRoutes.VIRTUAL_TOUR:
            dispatch(ListingActions.setVirtualTourModalOpen(true));
            break;
        case availableRoutes.DATE_PICKER:
            dispatch(ListingActions.openDatePickerModal());
            break;
        case availableRoutes.GUEST_SELECTOR:
            dispatch(ListingActions.openGuestSelectorModal());
            break;
        default:
            break;
    }
}
/* eslint-enable complexity */

const isSameRoute = (oldPath, newPath) => oldPath === newPath;

function changeRoute(store, action = {payload: {}}) {
    const {search} = action.payload;
    const {dispatch} = store;

    const {systemReducer, router} = store.getState();
    const {isMobile, baseUrlPath} = systemReducer;

    const previousPath = `${baseUrlPath}${router.search}` || baseUrlPath;
    const nextPath = `${baseUrlPath}${search}`;

    if (isMobile && !isSameRoute(previousPath, nextPath)) {
        previousMobilePathActions(previousPath, baseUrlPath, dispatch);
        nextMobilePathActions(nextPath, baseUrlPath, dispatch);
    }
}

function checkIfFromListingPage(store) {
    const state = store.getState();
    const {baseUrlPath, routerHistoryIndex} = state.systemReducer;
    const previousPath = `${baseUrlPath}${state.router.search}`;

    let result = null;

    if (previousPath === baseUrlPath) {
        result = RouterActions.go(-routerHistoryIndex);
    }

    return result;
}

export {
    matchRoute,
    previousMobilePathActions,
    nextMobilePathActions,
    changeRoute,
    checkIfFromListingPage
};
